import React from 'react';
import './App.css';

function App() {
  const handleEmailClick = () => {
    const email = 'info@nexapromos.com';
    window.location.href = `mailto:${email}`;
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white shadow-lg rounded-lg p-8 md:p-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center uppercase tracking-wide">
            Disclaimer
          </h1>
          
          <div className="prose prose-gray max-w-none space-y-6 text-gray-700 leading-relaxed">
            <p className="font-medium text-gray-800">
              The information provided on websites, landing pages, and digital properties operated or controlled by Nexa Nova Media LLC (“Company,” “we,” “us,” or “our”) is for general informational and marketing purposes only.
            </p>

            <p>
              By accessing or using any of our websites or content, you acknowledge and agree to this Disclaimer.
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                No Professional Advice
              </h2>
              <p>
                Nothing on our websites should be interpreted as professional advice of any kind, including but not limited to financial, legal, medical, health, or business advice.
              </p>
              <p>
                You should always consult with a qualified professional before making decisions based on information obtained from our websites.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                No Guarantees or Typical Results
              </h2>
              <p>
                We make no representations, warranties, or guarantees regarding results, outcomes, earnings, income, health improvements, or performance of any kind.
              </p>
              <p>
                Any examples, testimonials, case studies, or demonstrations presented are not intended to represent or guarantee that anyone will achieve the same or similar results. Individual results will vary based on numerous factors beyond our control.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                Affiliate & Third-Party Disclaimer
              </h2>
              <p>
                Our websites may contain links to third-party products, services, or offers. Some of these links may be affiliate links, meaning we may receive compensation if you choose to make a purchase through them, at no additional cost to you.
              </p>
              <p>
                We do not own, control, or endorse any third-party products, services, claims, or representations unless explicitly stated. Any interaction, transaction, or purchase you make with a third party is solely between you and that third party.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                Advertising Disclosure
              </h2>
              <p>
                Our content may include advertisements, sponsored content, paid placements, or promotional material. Compensation received may influence how, where, or whether products or services are featured.
              </p>
              <p>
                We strive to provide accurate information, but we do not guarantee the completeness, reliability, or accuracy of any content.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                External Links Disclaimer
              </h2>
              <p>
                Our websites may contain links to external websites that are not provided or maintained by us. We do not guarantee the accuracy, relevance, timeliness, or completeness of any information on external websites.
              </p>
              <p>
                We are not responsible for the content, privacy practices, or terms of use of any third-party websites.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                Limitation of Liability
              </h2>
              <p>
                To the maximum extent permitted by law, Nexa Nova Media LLC shall not be liable for any direct, indirect, incidental, consequential, special, or punitive damages arising out of your access to or use of our websites, reliance on information provided, or interaction with third-party offers.
              </p>
              <p>
                Your sole remedy for dissatisfaction with our websites or content is to discontinue use.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                Assumption of Risk
              </h2>
              <p>
                By using our websites, you understand and agree that any actions you take based on information provided are taken at your own risk.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">
                Changes to This Disclaimer
              </h2>
              <p>
                We reserve the right to update or modify this Disclaimer at any time without prior notice. Changes will be effective immediately upon posting.
              </p>
              <p>
                We encourage you to review this page periodically for updates.
              </p>
            </section>

            <section className="bg-gray-50 p-6 rounded-lg border border-gray-100 mt-12">
              <h2 className="text-xl font-bold text-gray-900 mb-4">
                Contact Information
              </h2>
              <p className="mb-2">If you have any questions about this Disclaimer, please contact us at:</p>
              <div className="space-y-1">
                <p><span className="font-semibold">Company:</span> Nexa Nova Media LLC</p>
                <p>
                  <span className="font-semibold">Email:</span>{' '}
                  <button
                    onClick={handleEmailClick}
                    className="text-blue-600 hover:text-blue-800 underline cursor-pointer bg-transparent border-none p-0 font-inherit"
                    aria-label="Contact us via email"
                  >
                    info [at] nexapromos [dot] com
                  </button>
                </p>
              </div>
            </section>

            <div className="mt-12 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-500 text-center">
                Last updated: January 24, 2025
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;